import { Sparkles } from "lucide-react";

export const AI_FILM = "AI Film";
export const isAiFilm = (film) => film?.genre === AI_FILM;

// Disclosure label for films in the AI Film genre; renders nothing otherwise.
export function AiBadge({ film, className = "" }) {
  if (!isAiFilm(film)) return null;
  return (
    <span
      className={`z-10 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-sky-500/90 backdrop-blur text-white text-[10px] font-bold uppercase tracking-wider border border-sky-300/40 shadow-md shadow-black/40 ${className}`}
      title="This film was made with generative AI"
      aria-label="AI-generated film"
      data-testid={`ai-badge-${film.id}`}
    >
      <Sparkles className="w-3 h-3" /> AI-generated
    </span>
  );
}
